export default "__VITE_ASSET__BCnoE1Pb__"